import { SET_USER } from './mutationTypes'

const mutations = {
  [SET_USER](state, { username = '', email = '', authorities = [] } = {}) {
    state.user = { username, email, authorities }
  }
}

export default mutations
